module.exports = __webpack_public_path__ + "img/logo-big.bb143f1d.svg";